import { render, staticRenderFns } from "./MediaUpdateDialog.vue?vue&type=template&id=456c81d6&scoped=true"
import script from "./MediaUpdateDialog.vue?vue&type=script&lang=js"
export * from "./MediaUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./MediaUpdateDialog.vue?vue&type=style&index=0&id=456c81d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c81d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456c81d6')) {
      api.createRecord('456c81d6', component.options)
    } else {
      api.reload('456c81d6', component.options)
    }
    module.hot.accept("./MediaUpdateDialog.vue?vue&type=template&id=456c81d6&scoped=true", function () {
      api.rerender('456c81d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/MediaUpdateDialog.vue"
export default component.exports